import { render } from "./DocumentListItem.vue?vue&type=template&id=33db3234"
import script from "./DocumentListItem.vue?vue&type=script&lang=js"
export * from "./DocumentListItem.vue?vue&type=script&lang=js"

import "./DocumentListItem.vue?vue&type=style&index=0&id=33db3234&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__